export default {
  menu_greek: "Greek",
  menu_english: "English",
  menu_Home: "Home",
  menu_services: "Solutions",
  menu_projects: "Work",
  menu_research: "AI Research",
  menu_sites: "Sites",
  menu_about: "Company",
  menu_contact: "Contact",
  menu_getOffer: "Talk to us",
  menu_startProject: "Start a project",
  submenu_title_Development: "Development",
  submenu_CustomDesktop: "Desktop & machines",
  submenu_WebApplications: "Web applications",
  submenu_MobileApplications: "Mobile applications",
  submenu_ECommerce: "E-Commerce",
  submenu_ApiDevelopment: "API development",
  submenu_MachineLearning: "AI & Alexander",
  submenu_DigitalConsulting: "Automation",
  submenu_DigitalMarketing: "Digital marketing",
  submenu_BusinessStrategy: "Business strategy",
  submenu_BrandDevelopment: "Brand development",
  submenu_WebsiteDevelopment: "Websites & SEO",
  submenu_DesignUIUX: "UI/UX design",
  submenu_CloudSolutions: "Cloud solutions",
  submenu_WhoAreWe: "Who we are",
  submenu_WithAiPath: "With AiPath",
  submenu_WhyAiPath: "Why AiPath",
  submenu_Team: "Team",
  submenu_Careers: "Careers",
  submenu_Contact: "Contact",
  submenu_Iso: "Quality & ISO",
  menu_news: "News",
  menu_language: "Language",
  nav: {
    solutions: [
      { title: "Business operating systems", text: "Business platforms from order intake to reporting.", path: "/services" },
      { title: "Automation", text: "Workflows, integrations and fewer manual operations.", path: "/digital-consulting" },
      { title: "Web applications", text: "Portals, dashboards, CRMs and custom tools.", path: "/web-apps" },
      { title: "Mobile applications", text: "Apps for field teams, logistics and customers.", path: "/mobile-apps" },
      { title: "Desktop & machines", text: "Software for local workflows, hardware and production.", path: "/custom-apps" },
      { title: "AI & Alexander", text: "AI assistants, Greek language research and private data.", path: "/machine-learning-solutions" },
      { title: "Websites & SEO", text: "Serious presence, speed, content and trust.", path: "/website-development" },
    ],
    company: [
      { label: "Who we are", path: "/about" },
      { label: "Why AiPath", path: "/why-aipath" },
      { label: "With AiPath", path: "/with-aipath" },
      { label: "Quality & ISO", path: "/iso" },
      { label: "Contact", path: "/contact" },
    ],
  },
  footer: {
    description: "Software engineering, business automation and applied AI for companies that need clean operations and a reliable technical foundation.",
    certification: "Certification & quality",
    solutions: "Solutions",
    company: "Company",
    contact: "Contact",
    rights: "All rights reserved.",
  },
  common: {
    home: "Home",
    nextStep: "Next step",
    discussNeed: "Discuss the need",
    contact: "Contact",
    startDiagnosis: "Start diagnosis",
    readService: "Read service",
    viewCase: "View project",
    startExploration: "Start the exploration",
    discussProject: "Discuss project",
  },
  home: {
    hero: {
      eyebrow: "AIPath Enterprise Software",
      title: "Software that organizes the entire business.",
      subtitle: "Applications, automations and AI, designed as one unified system.",
      text: "We build business operating systems for companies that need clean processes, real data and a technical foundation that can handle daily use.",
      primary: "Discuss your project",
      secondary: "See our work",
    },
    servicesHeader: {
      eyebrow: "Services",
      title: "Four pillars for serious digital operations.",
      text: "Our work connects applications, automation, web presence and applied AI around the way the business actually operates.",
    },
    services: [
      { index: "01", title: "Business operating systems", text: "One system for roles, workflows, data and daily decisions.", features: ["Workflows", "Roles and approvals", "Reports"], path: "/services" },
      { index: "02", title: "Action automation", text: "Integrations and triggers that reduce repetition, delays and mistakes.", features: ["API integrations", "Notifications", "Audit logs"], path: "/digital-consulting" },
      { index: "03", title: "Websites & Web Apps", text: "Serious digital presence and web tools with clear user experience.", features: ["SEO foundation", "Portals", "Admin panels"], path: "/website-development" },
      { index: "04", title: "AI & Alexander Research", text: "Applied AI and Greek language research with practical business usage.", features: ["Greek data", "Model layer", "AI assistants"], path: "/machine-learning-solutions" },
    ],
    casesHeader: {
      eyebrow: "Case studies",
      title: "Work that shows depth.",
      text: "Examples from vertical platforms, logistics applications, workforce automation and public websites.",
    },
    cases: [
      { id: "foodeat", title: "Foodeat", category: "Vertical business platform", text: "A vertical platform for a food supply company.", tags: ["Orders", "Warehouse", "Delivery", "Reports"], path: "/services" },
      { id: "pandora", title: "Pandora", category: "Transport operations", text: "Operational application for transport and access needs.", tags: ["Logistics", "Access", "Operations", "Support"], path: "/web-apps" },
      { id: "ora", title: "Ora / Workcard.gr", category: "Workforce automation", text: "Scanner and flows for attendance, time and teams.", tags: ["Scanner", "Time", "Teams", "Automation"], path: "/digital-consulting" },
      { id: "democrats", title: "democrats-pc.gr", category: "Website / digital presence", text: "Public site with clean information architecture.", tags: ["Website", "Content", "SEO", "Responsive"], path: "/website-development" },
      { id: "adopto", title: "Adopto.gr", category: "Mobile / social impact app", text: "Adoption platform with mobile experience for citizens and organizations.", tags: ["Mobile", "Adoptions", "CMS", "UX"], path: "/mobile-apps" },
    ],
    research: {
      eyebrow: "Alexander R&D",
      title: "Applied AI research for Greek data and real business usage.",
      text: "Alexander is not presented as a simple chatbot. It is a research layer for knowledge, evaluation, automations and tools that enter business workflows.",
      stages: [
        { title: "Greek Data", text: "Greek corpus, domain knowledge and clean data preparation." },
        { title: "Model Layer", text: "Retrieval, prompting, inference and guardrails for production use." },
        { title: "Evaluation", text: "Answer checks, logs and measurable quality improvement." },
        { title: "Business Usage", text: "Connection with applications, processes and daily work tools." },
      ],
    },
    planner: {
      eyebrow: "Project planner",
      title: "Which need should we solve first?",
      text: "Choose a direction and see the first questions that must be answered before the system is designed correctly.",
      options: [
        { id: "operations", label: "Business organization", title: "Operational mapping", text: "We start with departments, roles, data and bottlenecks.", questions: ["Which process is delayed the most?", "Which roles approve or update work?", "Where is the data stored today?"] },
        { id: "automation", label: "Automation", title: "Flows that run automatically", text: "We identify repetitions, integrations and notifications worth automating.", questions: ["Which actions are done manually every day?", "Which systems must talk to each other?", "Which mistakes cost time?"] },
        { id: "web", label: "Web application", title: "Tool for daily use", text: "We define users, permissions, dashboards and the data model.", questions: ["Who will use the system?", "What should each role see?", "Which reports are needed?"] },
        { id: "ai", label: "AI / Alexander", title: "AI with practical purpose", text: "We check whether your data and flows can support AI usage.", questions: ["Which knowledge should be searchable?", "Are there Greek documents or conversations?", "Where should answers be evaluated?"] },
        { id: "unknown", label: "Not sure", title: "Start with diagnosis", text: "Describe the need and we propose the first correct step.", questions: ["What is most tiring today?", "Which team is affected?", "Which result would make a difference?"] },
      ],
    },
    process: {
      eyebrow: "Process",
      title: "Discovery → Architecture → Build → Operate",
      steps: [
        { number: "01", title: "Discovery", text: "Need, users and data mapping." },
        { number: "02", title: "Architecture", text: "System, integrations and technical plan." },
        { number: "03", title: "Build", text: "Implementation with real workflows and feedback." },
        { number: "04", title: "Operate", text: "Support, measurement and improvement." },
      ],
    },
    finalCta: {
      eyebrow: "AIPath",
      title: "Bring us a need. We will turn it into a system.",
      text: "From applications and sites to automations and applied AI, the goal is clean operation and reliable delivery.",
      button: "Discuss project",
    },
  },
  servicePages: {
    operations: {
      eyebrow: "Business operating systems",
      title: "Vertical business organization from the first action to the final report.",
      lead: "AIPath designs and builds platforms that connect departments, people, data and processes. We do not simply build an app. We build the operating system of a business.",
      systemLabel: "vertical platform",
      highlights: ["Orders", "Warehouse", "Deliveries", "People"],
      pillarTitle: "As the business grows, software must keep the structure clear.",
      pillars: [
        { icon: "flaticon-solution", title: "Unified platform", text: "Roles, approvals, tasks, reports and dashboards in an environment that follows how the company works." },
        { icon: "flaticon-resource", title: "Action automation", text: "Notifications, repeated tasks, data transfers and triggers that reduce mistakes and delays." },
        { icon: "flaticon-analytics", title: "Management visibility", text: "Measurable data, clean reports and operational visibility without chasing files manually." },
      ],
      proofTitle: "Projects like Foodeat, Pandora and Ora show the depth of this approach.",
      proofText: "Every sector has its own pressure points. We map them, turn them into flows and deliver systems used every day.",
      proofItems: ["Foodeat: vertical food supply application", "Pandora: operational transport framework", "Ora / Workcard.gr: people and time workflows", "democrats-pc.gr: clean information architecture"],
      ctaTitle: "Shall we organize your operation vertically?",
      ctaText: "We start by analyzing processes, finding automation points and designing the system that makes sense for your team.",
    },
    automation: {
      eyebrow: "Automation consulting",
      title: "Action automation that removes noise from daily operations.",
      lead: "We study repetitive company actions and turn them into workflows, notifications, integrations and controlled operations.",
      systemLabel: "automation map",
      highlights: ["Tasks", "APIs", "Reports", "Alerts"],
      pillarTitle: "Good automation starts with understanding the process.",
      pillars: [
        { icon: "flaticon-resource", title: "Workflow mapping", text: "Analysis of daily actions, delays and decisions that can become clearer." },
        { icon: "flaticon-automation", title: "Integrations", text: "Connecting applications, APIs, data and notifications so information moves automatically." },
        { icon: "flaticon-analytics", title: "Monitoring", text: "Reports, logs and dashboards so you know what happened, when and who must act." },
      ],
      proofTitle: "From simple notifications to full action organization.",
      proofText: "The value is not automating something just because it happens. It is placing it correctly, with control, history and permissions.",
      proofItems: ["Automated notifications and tasks", "Forms, CRM, ERP or custom app connection", "Reports without manual collection", "AI-assisted classification and search"],
      ctaTitle: "Shall we find what should be automated first?",
      ctaText: "We can map the core flows and propose a practical first stage with fast value and a proper foundation.",
    },
    webapps: {
      eyebrow: "Web applications",
      title: "Web applications that become the operating center of a team.",
      lead: "We build portals, dashboards, admin panels, CRMs and custom web applications with clear architecture, security and daily-use UX.",
      systemLabel: "web platform",
      highlights: ["Dashboards", "Portals", "Roles", "APIs"],
      pillarTitle: "From internal tools to full operational platforms.",
      pillars: [
        { icon: "flaticon-web-optimization", title: "Portals & dashboards", text: "Central data view, role-based actions and reporting for management and teams." },
        { icon: "flaticon-develop", title: "Custom workflows", text: "Workflows that follow the real operating model of the company." },
        { icon: "flaticon-analytics", title: "Scalable backend", text: "APIs, databases, permissions and integrations that grow with the project." },
      ],
      proofTitle: "A web app should organize work, not add another screen.",
      proofText: "We design around roles, data, permissions and critical actions so the app is fast, understandable and reliable.",
      proofItems: ["Admin panels", "Customer portals", "Operations dashboards", "Integrations with existing systems"],
    },
    mobile: {
      eyebrow: "Mobile applications",
      title: "Mobile applications for teams that move, serve and execute work.",
      lead: "We create mobile apps for customers, drivers, technicians, sales and internal teams, connected to backend systems and real workflows.",
      systemLabel: "mobile workflow",
      highlights: ["iOS", "Android", "Backend", "Push"],
      pillarTitle: "The phone becomes a production tool, not just an app in the store.",
      pillars: [
        { icon: "flaticon-mobile-app", title: "Field workflows", text: "Flows for drivers, technicians, deliveries, checks and teams working outside the office." },
        { icon: "flaticon-notification", title: "Connected experience", text: "Push notifications, data sync and connection with web admin or existing systems." },
        { icon: "flaticon-analytics", title: "Operational visibility", text: "Clean field usage data, reports and progress visibility." },
      ],
      proofTitle: "Ideal for logistics, deliveries, field services and customer experience.",
      proofText: "The mobile app has value when it connects with operations, not only with a polished screen.",
      proofItems: ["Driver and delivery flows", "Push notifications", "Offline-aware experiences when needed", "Connection with web admin and data"],
    },
    desktop: {
      eyebrow: "Desktop, hardware & machines",
      title: "Custom desktop applications for serious environments, machines and local workflows.",
      lead: "When the work does not fit into a simple web form, we design desktop applications connected to devices, files, local networks and production.",
      systemLabel: "local system",
      highlights: ["Hardware", "Files", "Local network", "Reports"],
      pillarTitle: "Software for points where reliability is critical.",
      pillars: [
        { icon: "flaticon-develop", title: "Local-first workflows", text: "Applications that operate close to the process, in offices, warehouses, labs or production." },
        { icon: "flaticon-resource", title: "Hardware integration", text: "Connection with devices, scanners, machines, files or internal networks." },
        { icon: "flaticon-analytics", title: "Central visibility", text: "Data collection and reporting to central systems where needed." },
      ],
      proofTitle: "These applications require technical understanding beyond the UI.",
      proofText: "We design around the environment, operators, data and reliability that the job requires.",
      proofItems: ["Special operator forms", "File and device connection", "Local-first operation", "Reports and central visibility"],
    },
    websites: {
      eyebrow: "Websites, SEO & digital presence",
      title: "Websites that inspire trust and clearly explain your work.",
      lead: "We build company websites, portals and digital presences with serious UX, fast loading, proper SEO foundation and content that helps visitors understand.",
      systemLabel: "digital presence",
      highlights: ["SEO", "Content", "Performance", "Trust"],
      pillarTitle: "The site should show professionalism before the customer speaks to you.",
      pillars: [
        { icon: "flaticon-web-optimization", title: "Information architecture", text: "Clear structure, messaging and pages that help visitors understand value quickly." },
        { icon: "flaticon-search-engine", title: "SEO foundation", text: "Technical base, metadata, headings, speed and content that can evolve." },
        { icon: "flaticon-design", title: "Premium UI", text: "Serious, clean aesthetics without stock imagery or generic template feeling." },
      ],
      proofTitle: "From company presence to applications and portals with real purpose.",
      proofText: "The website is part of the overall infrastructure and can connect with forms, automations, dashboards and AI assistants.",
      proofItems: ["Company websites", "Portals like democrats-pc.gr", "SEO-ready structure", "Connection with apps and AI assistants"],
      examplesEyebrow: "Selected sites",
      examplesTitle: "Examples of websites we have built.",
      examples: [
        { image: "rgsecurity", title: "RG Security", category: "Security services website", text: "Premium corporate presence for guarding and protection services with strong identity and clear navigation.", tags: ["Corporate", "Bilingual", "UX", "Performance"], url: "https://rgsecurity.gr/" },
        { image: "parad", title: "PARAD Construction", category: "Construction website", text: "Corporate site for a construction company, presenting projects, services and a serious visual presence.", tags: ["Corporate", "Projects", "Content", "Responsive"], url: "https://parad.gr/" },
      ],
      ctaTitle: "Shall we make your presence clearer and stronger?",
      ctaText: "We start from value, audience, content and business goals.",
    },
    ai: {
      eyebrow: "AI, Machine Learning & Alexander",
      title: "AI grounded in research, data and real business needs.",
      lead: "AIPath works on the Greek language model Alexander and AI solutions that do not stop at a simple chatbot endpoint.",
      systemLabel: "Alexander R&D",
      highlights: ["Greek NLP", "Private data", "AI assistants", "Evaluation"],
      pillarTitle: "AI capabilities that can enter the company's real work.",
      pillars: [
        { icon: "flaticon-brain", title: "Alexander research", text: "Greek language understanding, datasets, answer evaluation and experimentation on serious infrastructure." },
        { icon: "flaticon-chat", title: "AI assistants", text: "Assistants that answer based on company knowledge, processes, products and real business data." },
        { icon: "flaticon-automation", title: "AI automation", text: "Connecting AI with workflows, tickets, emails, reports, searches and internal tools." },
      ],
      proofTitle: "Research gains value when it reaches stable production use.",
      proofText: "We connect models, data, evaluation and applications so the customer sees a controlled system with clear boundaries.",
      proofItems: ["Not a simple ChatGPT connection without architecture", "Prompts, retrieval, permissions and fallback behavior", "Answer quality checks and logging", "Connection with existing AIPath applications"],
      ctaTitle: "Shall we see where AI can enter your operation?",
      ctaText: "We evaluate data, documents, communication and repeated decisions to find practical AI applications.",
    },
  },
  standardPages: {
    about: {
      eyebrow: "Company",
      title: "A Greek software engineering team for real business needs.",
      lead: "We design and build applications, automations and applied AI so everyday business operations become clearer and more organized.",
      sections: [
        { title: "What AIPath is", paragraphs: ["AIPath is an enterprise software engineering company focused on business operating systems, web and mobile applications, automation and AI with practical use.", "We do not approach software as an isolated screen. We see it as infrastructure connecting people, roles, data and decisions."] },
        { title: "How we work", paragraphs: ["We start from business operations: which actions happen, where information is lost, which data is needed and who uses the system.", "From there we design architecture, deliver gradually and keep the project close to real usage."], points: ["Discovery before implementation", "Clean architecture", "Reliable delivery", "Support after launch"] },
        { title: "Where we focus", paragraphs: ["We focus on companies that need vertical organization, action automation, daily-use applications and AI connected to real data.", "Projects like Foodeat, Pandora, Ora / Workcard.gr, democrats-pc.gr and Adopto show the direction: not simple showcases, but software that does work."] },
      ],
      ctaTitle: "Shall we see what your business needs?",
      ctaText: "We can start with a practical discussion around your processes, data and goals.",
    },
    why: {
      eyebrow: "Why AIPath",
      title: "Why AIPath does not simply build applications.",
      lead: "The value is in how software organizes operations, reduces noise and gives the team a clearer view.",
      sections: [
        { title: "We think in systems", paragraphs: ["An application has value when it belongs to a clear operating framework. That is why we examine roles, processes, data, permissions and reporting before implementation starts."] },
        { title: "We build for daily use", paragraphs: ["Software must handle frequent use, exceptions, change and real work pressure. Aesthetics matter only when they serve clear operation."], points: ["Flows the team understands", "Permissions and history", "Reports that help management", "Foundation for future expansion"] },
        { title: "We connect software and AI", paragraphs: ["AI gains value when it enters applications, data and processes. With Alexander research and our applications, the goal is practical use, not spectacle."] },
      ],
      ctaTitle: "If you need a system, not just a screen, let us look at it.",
      ctaText: "Describe the operation you want to organize and we will propose the first clear step.",
    },
    with: {
      eyebrow: "With AIPath",
      title: "With AIPath you work on needs, not ready-made templates.",
      lead: "Every project starts with what the business must achieve and ends with a technical plan that can be built.",
      sections: [
        { title: "From conversation to plan", paragraphs: ["We record the problem, users, data and points where manual work or ambiguity exists today.", "Then we define what should happen first, what can wait and what technical foundation is needed."] },
        { title: "From plan to delivery", paragraphs: ["We work with clear modules, explained technical decisions and releases that can be tested by real users."], points: ["Architecture", "UI and workflows", "Backend and integrations", "Testing and support"] },
        { title: "After launch", paragraphs: ["Launch is not the end. We monitor usage, listen to friction points and improve the system as the business learns through it."] },
      ],
      ctaTitle: "Let us organize the next project.",
      ctaText: "Start with a description of the need and we will organize the exploration.",
    },
    iso: {
      eyebrow: "Quality",
      title: "Quality, security and responsible technical delivery.",
      lead: "Technical trust is built through process, documentation, consistency and respect for data.",
      sections: [
        { title: "Quality in practice", paragraphs: ["For us quality is not a decorative statement. It is the way a project is organized, decisions are documented and software is delivered so it can be maintained."] },
        { title: "Data security", paragraphs: ["Company data requires attention to access, permissions, logging, backup and technical architecture. This matters even more when automation or AI workflows enter the system."] },
        { title: "Stable operation", paragraphs: ["We design systems so they can be supported, evolved and kept clean as needs grow."], points: ["Clear documentation", "Careful permissions", "Change control", "Production support"] },
      ],
      ctaTitle: "Do you need a technical partner with process?",
      ctaText: "Let us discuss the quality and security framework your project needs.",
    },
    gdpr: {
      eyebrow: "Privacy",
      title: "GDPR and personal data protection.",
      lead: "Data protection is part of technical architecture, not just a formal obligation.",
      sections: [
        { title: "Core principle", paragraphs: ["We design applications and processes with respect for data minimization, access rights and transparency of use.", "Every project is examined based on the data it collects, its purpose and who has access."] },
        { title: "Technical approach", paragraphs: ["In business applications, forms, portals and AI workflows, data protection is connected with permissions, logs, secure storage and clear management flows."], points: ["Access limitation", "Action history", "Secure data transfer", "Clear processing purpose"] },
        { title: "Note", paragraphs: ["This page is informational and does not replace legal advice. For specific obligations, the business should consult its legal advisor or DPO."] },
      ],
      ctaTitle: "Shall we design the project data correctly?",
      ctaText: "We can examine the data flow together with the technical architecture.",
    },
    tos: {
      eyebrow: "Security",
      title: "Information security policy.",
      lead: "AIPATH protects the confidentiality, integrity and availability of information across its client work and business operations.",
      sections: [
        { title: "Policy purpose", paragraphs: ["This policy aims to protect AIPATH's information from internal and external threats, ensuring the confidentiality, integrity and availability of data for both clients and business operations."] },
        { title: "Scope", paragraphs: ["The policy applies to all employees, partners and external suppliers who have access to AIPATH's information systems, data and infrastructure."] },
        { title: "Fundamental principles", paragraphs: ["Through its management, AIPATH is committed to adhering to the following fundamental principles of information security:"], points: ["Confidentiality: Client and company data is accessible only to authorized individuals.", "Integrity: Information remains accurate and complete, preventing unauthorized modifications.", "Availability: Information and systems are accessible when needed."] },
        { title: "Risk management", paragraphs: ["The company adopts a continuous risk management process, including regular identification and assessment of threats related to information security."] },
        { title: "Employee responsibilities", paragraphs: ["AIPATH employees have the following responsibilities:"], points: ["Comply with the prescribed security procedures.", "Promptly report any security incidents or suspicious activities.", "Participate in training programs related to information security."] },
        { title: "Compliance", paragraphs: ["This policy fully complies with the ISO 27001:2022 standard, the General Data Protection Regulation (GDPR), and other applicable data security laws."] },
        { title: "Review and continuous improvement", paragraphs: ["The policy will be reviewed annually or whenever significant business changes occur to ensure the continuous improvement of the Information Security Management System (ISMS) along with regulation compliance, as committed by the company's management.", "The company provides ongoing training to employees, keeping them informed about security procedures and current threats in the field of information security.", "This policy has been approved by AIPATH's management and is communicated to all employees and partners for immediate implementation and compliance."] },
      ],
      ctaTitle: "Let us build the project on a secure foundation.",
      ctaText: "Good architecture at the start reduces risk and cost later.",
    },
  },
  seo: {
    "/": {
      title: "AiPath | Enterprise software, automation and applied AI",
      description: "AIPath builds business operating systems, web and mobile applications, automation and applied AI research with Alexander.",
    },
    "/home": {
      title: "AiPath | Enterprise software, automation and applied AI",
      description: "AIPath builds business operating systems, web and mobile applications, automation and applied AI research with Alexander.",
    },
    "/services": {
      title: "Business operating systems | AiPath",
      description: "Custom business platforms for orders, warehouse, people, logistics, dashboards and full operational automation.",
    },
    "/digital-consulting": {
      title: "Business automation | AiPath",
      description: "Workflow automation, integrations, reports and AI-assisted processes for less manual work.",
    },
    "/web-apps": {
      title: "Web applications | AiPath",
      description: "Portals, dashboards, CRMs and custom web applications with clean architecture and daily operational use.",
    },
    "/mobile-apps": {
      title: "Mobile applications | AiPath",
      description: "Mobile apps for iOS and Android, connected with backend, analytics and business workflows.",
    },
    "/custom-apps": {
      title: "Desktop applications and machines | AiPath",
      description: "Custom desktop software for local workflows, hardware, machines, production and demanding environments.",
    },
    "/website-development": {
      title: "Website development and SEO | AiPath",
      description: "Websites, portals and digital presence with serious UX, technical SEO foundation and AI integration potential.",
    },
    "/machine-learning-solutions": {
      title: "AI & Alexander Research | AiPath",
      description: "Applied AI solutions, assistants and research on the Greek language model Alexander for real business usage.",
    },
    "/contact": {
      title: "Contact | AiPath",
      description: "Talk to AIPath about custom applications, automation, websites and applied AI.",
    },
    "/project-idea": {
      title: "Project intake | AiPath",
      description: "Describe your company and project so the exploration starts correctly.",
    },
    "/about": {
      title: "Who we are | AiPath",
      description: "AIPath is a Greek enterprise software engineering, business automation and applied AI company.",
    },
    "/why-aipath": {
      title: "Why AiPath | Enterprise software engineering",
      description: "Learn how AIPath designs software as an operating system for businesses, not just isolated applications.",
    },
    "/with-aipath": {
      title: "With AiPath | From need to system",
      description: "How AIPath works from discovery and architecture to build, operate and continuous improvement.",
    },
    "/iso": {
      title: "Quality and security | AiPath",
      description: "AIPath's approach to quality, security and responsible technical delivery for applications, automation and AI workflows.",
    },
    "/gdpr": {
      title: "GDPR and data protection | AiPath",
      description: "Information about AIPath's approach to personal data protection and proper technical architecture.",
    },
    "/tos": {
      title: "Information security policy | AiPath",
      description: "AIPath's approach to information security for applications, automation and AI workflows.",
    },
  },
};
